module.exports = __webpack_public_path__ + "static/rae-spriggs-5333e0f0089f42c6cb547b21f0062795.jpg";